import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserLandscapeGame from 'src/games/demos/LandscapingDemo/Main';

interface LandscapingGameProps extends PageProps<{}> {
}

class LandscapingGame extends React.Component<LandscapingGameProps> {
    constructor(props: LandscapingGameProps) {
        super(props);
        bindAllOfThis(this, LandscapingGame.prototype);
    }

    render() {
        return <div>
            <PhaserLandscapeGame />
        </div>;
    }
}

export default LandscapingGame;



// WEBPACK FOOTER //
// ./src/pages/game/demos/LandscapingDemo.tsx